import React from 'react';
import styled from 'styled-components';
import GroupLabelStation from './GroupLabelStation';

const GroupMemberTopBar: React.FC = () => {
  return (
    <TopBar>
      <GroupLabelStation />
    </TopBar>
  );
};

export default GroupMemberTopBar;

const TopBar = styled.div`
  width: 100%;
  height: calc(14vh);
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 5vw;
  margin-bottom: 0.5vh;
`;
